export const common = {
  cancel: 'Cancel',
  retry: 'Retry',
  back: 'Back',
  close: 'Close',
  logOut: 'Log out',
  couldNotLoad: "Couldn't load this",
  somethingWentWrong: 'Something went wrong. Please try again.',
  couldNotLoadNow: "Couldn't load this right now.",

  pageNotFound: 'Page not found',
  pageNotFoundBody: "This link is broken or the page doesn't exist.",
  goHome: 'Go to home',

  updateRequired: 'Update required',
  updateRequiredBody: 'Please update Tupai to continue.',
  updateNow: 'Update now',
  updateDownloading: 'Checking and installing an update. Please keep the app open.',
  updateDownloadFailed: 'Could not install the update. Check your connection and try again.',
  updateRetry: 'Try again',

  openProfile: 'Open profile',
  notifications: 'Notifications',
  noNotifications: 'No notifications yet',
  noNotificationsBody:
    'Finished homework, new reports and link requests from your children will appear here.',
  planChip: {
    trial: 'TRIAL',
    pro: 'PRO',
    pending: 'PENDING',
    payment: 'PAYMENT',
    free: 'FREE',
  },
  notifHomeworkDone: '{childName} finished their homework',
  notifReportReady: "{childName}'s new report is ready",
  notifLinkRequest: '{childName} wants to link with you',
  notifTrialEnding: 'Your free trial is ending',
  notifChildTrialEnding: "{childName}'s free trial is ending soon",
  notifReviewRequest: 'Review the request',
  notifChildTrialEndsOn: 'Ends {date} — add them to your plan to keep full access',

  navMain: 'Main',
  navChildren: 'Children',
  navPractice: 'Practice',
  navExam: 'Exam',
  navNews: 'News',
  navProfile: 'Profile',

  profileAndSettings: 'Profile & Settings',
  childFallback: 'Child',
  childReports: "{childName}'s reports",
  childHomework: "{childName}'s homework",
  childActivity: "{childName}'s activity",

  newsTitle: 'Parent News & Tips',
  comingSoon: 'Coming Soon',
  newsBody: "We're working on tutoring tips and curriculum updates for you. Check back soon!",

  weekOf: 'Week of {from} – {to}',
  dayToday: 'TODAY',
  dayYesterday: 'YESTERDAY',

  pdfProgressSummary: 'Progress Summary',
  pdfPastDays: '{days, plural, one {Past {days} day} other {Past {days} days}}',
  pdfAppUsage: 'App Usage',
  pdfActiveDays: 'Active Days',
  pdfTotalTime: 'Total Time',
  pdfAvgPerDay: 'Avg / Day',
  pdfTwoWeeksAgo: '2 weeks ago',
  pdfLastWeek: 'Last week',
  pdfToday: 'Today',
  pdfOverview: 'Overview',
  pdfKeyStrengths: 'Key Strengths',
  pdfAreasToFocus: 'Areas to Focus',
  pdfRecommendations: 'Recommendations',
  pdfStrengthsFallback: 'Building foundational skills through regular practice.',
  pdfFocusFallback: 'Continue consistent daily practice to reinforce all topics.',
  pdfFooter: 'Generated by Tupai · AI Mathematics Tutor',

  toastApproved: 'Request approved!',
  toastRejected: 'Request rejected.',
  toastRevoked: 'Link removed.',
  errLinkActionFailed: "That didn't work. Please try again.",
  errRequestGone:
    'This request is no longer available — it may have been cancelled or already handled.',
  errRegenerateCode: 'Could not regenerate your code.',
  errWorksheetFailed: 'Could not generate the worksheet.',

  errConsentOutdated: 'This screen is out of date. Reload or update the app, then try again.',
  errSeatLimit: 'Your plan has no free seat left. Upgrade to add another child.',
  errTrialSeatLocked: 'You can add more children once your trial becomes a paid plan.',
  errFeatureBlocked: 'Your current plan does not include this.',
  errUpgradeRequired: 'Upgrade your plan to use this.',
  errQuotaExhausted: "You've used this month's allowance. It resets next month.",
  errStudentAlreadyLinked: 'This child is already linked to another parent.',
  errAlreadyInHousehold: 'This child is already on a plan.',
  errCooldown: 'Please wait a moment before trying that again.',
  errNotStarted: 'There is nothing to show yet.',
  errCodeExpired: 'That code has expired. Ask for a new one.',
  errCodeNotFound: "We couldn't find that code. Check it and try again.",
  errPhoneInUse: 'This phone number is already registered. Please log in instead.',
  errAccountNotFound: 'This account does not exist.',
  errUnauthorised: 'Your session has ended. Please sign in again.',
  errNoHousehold: 'You do not have a plan yet.',
  pushChannelName: 'Learning updates',
  pushChannelDescription: 'Updates about your children’s learning',
} as const;
